import React, { useState } from "react";

import {
  Box,
  Button,
  Column,
  Columns,
  Control,
  Field,
  Pagination,
  Table,
  Tabs,
  TextArea,
} from "@allxsmith/bestax-bulma";

import {getDataFresh, getDepartmentsData, getQuotesData} from "../../state/selectors";
import {useDispatch, useSelector} from "react-redux";
import Spinner from "react-spinner-material";
import { useQuotesData } from "../../hooks/useQuotesData";
import useSelect from "../../hooks/useSelect";
import {formatDate, readableDate} from "../../utils";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import DepartmentPicker from "../Job/DepartmentPicker";
import FilterBlankHeading from "../Invoicing/FilterBlankHeading";
import FilterHeading from "../Invoicing/FilterHeading";
import SearchBar from "../Utils/SearchBar";
import axios from "axios";
import {createSetDataFreshAction} from "../../actions/dataActions";
import {ToastContainer, toast} from "react-toastify";
import InfoModal from "./InfoModal";
import Nav from "../Nav/Nav";
import PaginationWrapper from "../Utils/PaginationWrapper";
import LoadingSpinner from "../Utils/Spinner";

function Quote(props) {
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState();
  const [currentSearch, setCurrentSearch] = useState();
  const [selectedDepartment, setSelectedDepartment] = useState();
  const [searchFresh, setSearchFresh] = useState(1);
  const [view, setView] = useState("started");
  const [infoOpen, setInfoOpen] = useState(false);
  let dataFresh = useSelector(getDataFresh);
  const dispatch = useDispatch();
  const options = [
      { name: "Quotes", value: "quotes" },
      { name: "Started", value: "started"},
      { name: "No Active Jobs", value: "no_active_jobs"},
      { name: "Awaiting Approval", value: "all_jobs_completed"},
      { name: "Approved", value: "approved" },
      { name: "All", value: "all"}
  ];

  const [priced, pricedInput] = useSelect({
    label: "Priced",
    options: [
      { name: "All", value: "all"},
      { name: "Priced", value: "true"},
      { name: "Not Priced", value: "false"}
    ],
    initialValue: "all",
    callback: () => {
      setPage(1);
    }
  })

  // const [view, viewInput] = useSelect({
  //   label: "View",
  //   options: [
  //     { name: "Quotes", value: "quotes" },
  //     { name: "Started", value: "started"},
  //     { name: "No Active Job", value: "no_active_job"},
  //     { name: "Awaiting Approval", value: "all_jobs_completed"},
  //     { name: "Approved", value: "approved" },
  //     { name: "All", value: "all"}
  //   ],
  //   initialValue: "quotes",
  //   testId: "part-view",
  //   callback: () => {
  //     setPage(1);
  //   }
  // });

  const departmentsLoaded = useDepartmentsData({}, dataFresh);
  const departments = useSelector(getDepartmentsData);
  let params = { page };
  const [filters, setFilters] = useState({});
  const headings = [
    {
        label: "Quote no.",
    },
    {
        label: "Registration",
        field: "vehicle",
        labelField: "vehicle__registration"
    },
    {
        label: "Description"
    },
    {
      label: "Priced Status"
    },
    {
      label: "Earliest Workshop Date",
    },
    {
      label: "Provisional Start Date",
      field: "provisional_start_date",
      labelField: "provisional_start_date",
      date: true,
      noBlank: true
    },
    {
      label: "Items Not Started"
    },
    {
      label: "Quote Type",
      field: "quote_type",
      labelField: "quote_type"
    },
    {
        label: "Comments"
    },
    {
      label: "Duplicate",
      field: "duplicate",
      labelField: "duplicate"
    },
    {
        label: "Customer",
        field: "customer",
        labelField: "customer__display_name"
    },
    {
        label: "Customer2",
        field: "customer2",
        labelField: "customer2__display_name"
    },
    {
      label: "Customer Invoice Number",
      field: "customer_invoice_number",
      labelField: "customer_invoice_number",
      blank: true
    },
    {
      label: "Customer2 Invoice Number",
      field: "customer2_invoice_number",
      labelField: "customer2_invoice_number",
      blank: true
    },
    {
        label: "Make"
    },
    {
        label: "Model"
    },
    {
      label: ""
    }
  ];

  for (let filter in filters) {
    if (filters[filter][0] && filters[filter][0][filter]) {
      params[filter] = filters[filter][0][filter];
    }
  }

  if(selectedDepartment){
    params.department = selectedDepartment;
  }

  if (currentSearch) {
    params.search = currentSearch;
  }
  if (searchFresh){
    params.searchFresh = searchFresh;
  }
  if (view) {
    params.view = view;
  }
  if(priced){
    params.priced = priced
  }

  const handleSearch = () => {
    setPage(1);
    setCurrentSearch(searchText);
    setSearchFresh(searchFresh+1);
  };

  const clear = () => {
    setSearchText("");
    setCurrentSearch("");
    setPage(1);
  };

  const complete = useQuotesData(params, dataFresh);
  const data = useSelector(getQuotesData);

  const onDepartmentChange = (e) => {
    setSelectedDepartment(e.target.value);
  }


  const onPriced = (e, index) => {
    let quoteToPrice = data.results[index];
    const conf = {
      url: props.endpoint+"quotes/priced",
      method: "put",
      data: quoteToPrice
    }
    axios(conf).then(res => {
      dispatch(createSetDataFreshAction(dataFresh + 1));
    }).catch(err => {
      toast.error("There was an error setting that quote as priced", {position: "top-right"})
    })
  }

  if (!complete || !departmentsLoaded) {
    return (
        <div>
          <Nav/>
          <LoadingSpinner/>
        </div>
    );
  }

  document.title = "Quotes";

  return (
    <div>
      <Nav/>
      <br/>
      <br/>
      <Box>
        <Columns isMultiline>
          <Column>
            <Button
              color={"info"}
              onClick={() => setInfoOpen(true)}
            >
              Info
            </Button>
          </Column>
          {pricedInput}
          <Column>
            <DepartmentPicker
              onDepartmentChange={onDepartmentChange}
              selectedDepartment={selectedDepartment}
              departments={departments}
            />
          </Column>
          <Column>
            <label className="label">Search for a Quote</label>
            <SearchBar
              handleSearch={handleSearch}
              setSearchText={setSearchText}
              searchText={searchText}
              clear={clear}
            />
          </Column>
          <Column>
            <Field>
              <Control>
                <Button
                  onClick={() => window.open("/editquote", "_self")}
                  color="success"
                  className="is-pulled-right"
                >
                  New Quote+
                </Button>
              </Control>
            </Field>
          </Column>
        </Columns>
      </Box>
      <Box>
        <Columns isMultiline>
          <Column>
            <h1 className="title">Quotes</h1>
          </Column>
        </Columns>
        <Tabs align="centered" toggle>
          <Tabs.List>
            {options.map(option => (
              <Tabs.Item active={view === option.value}><a onClick={() => setView(option.value)}>
                  {option.name}
                </a></Tabs.Item>
            ))}
          </Tabs.List>
        </Tabs>
        <Columns isMultiline>
          <Column>
            <Table className="table is-hoverable is-fullwidth is-striped" isFullwidth>
              <thead>
                <tr className="small-row-black">
                  {headings.map(heading => {
                    if (!heading.field) {
                      return <th key={heading.label}>{heading.label}</th>;
                    }
                    if (heading.blank) {
                      return (
                        <FilterBlankHeading
                          key={heading.label}
                          heading={heading}
                          setFilters={f => {
                            setPage(1);
                            setFilters(f);
                          }}
                          filters={filters}
                        />
                      );
                    }
                    return (
                      <FilterHeading
                        key={heading.label}
                        heading={heading}
                        setFilters={f => {
                          setPage(1);
                          setFilters(f);
                        }}
                        filters={filters}
                        options={data && data.filter_list[heading.field]}
                      />
                    );
                  })}
                  {view === 'approved' &&
                    <th>Approver</th>
                  }
                </tr>
              </thead>
              <tbody>
                {data  && data.results.map((value, index) => {
                  let highlightClass = "";
                  if (value.has_jobs) {
                    if (value.ready_for_approval) {
                      highlightClass = "table-highlight-green";
                    } else if(value.has_finished_and_not_started_jobs && !value.has_started_job){
                      highlightClass = "table-highlight-red";
                    } else {
                      highlightClass = "table-highlight-orange";
                    }
                  }
                  return (
                    <tr
                      className={`clickable small-row-black ${highlightClass}`}
                      onClick={() =>
                        window.open(`/editquote/${value.id}`, "_self")
                      }
                      key={value.id}
                    >
                      <td className={highlightClass === "table-highlight-red" ? "small-row-white" : ""}>{value.id}</td>
                      <td className={highlightClass === "table-highlight-red" ? "small-row-white" : ""}>{value.vehicle.registration}</td>
                      <td className={highlightClass === "table-highlight-red" ? "small-row-white" : ""}>{value.description}</td>
                      <td className={highlightClass === "table-highlight-red" ? "small-row-white" : ""}>{value.priced ? "Priced" : "Not Priced"}</td>
                      <td className={highlightClass === "table-highlight-red" ? "small-row-white" : ""}>{readableDate(value.earliest_workshop_date)}</td>
                      <td className={highlightClass === "table-highlight-red" ? "small-row-white" : ""}>{readableDate(value.provisional_start_date)}</td>
                      <td className={highlightClass === "table-highlight-red" ? "small-row-white" : ""}>{value.not_started_work_items}</td>
                      <td className={highlightClass === "table-highlight-red" ? "small-row-white" : ""}>{value.quote_type}</td>
                      <Field className="has-addons">
                        <Control>
                          <TextArea
                            rows={2}
                            className="small-row-black min-column-width"
                            type="text"
                            value={value.comments_list.length > 0 ? readableDate(formatDate(new Date(value.comments_list[value.comments_list.length -1].created))) +"\n"+ value.comments_list[value.comments_list.length -1].text : ""}
                            disabled
                            readOnly
                          />
                        </Control>
                      </Field>
                      <td className={highlightClass === "table-highlight-red" ? "small-row-white" : ""}>{value.duplicate ? "YES" : "NO"}</td>
                      <td className={highlightClass === "table-highlight-red" ? "small-row-white" : ""}>{value.customer}</td>
                      <td className={highlightClass === "table-highlight-red" ? "small-row-white" : ""}>{value.customer2}</td>
                      <td className={highlightClass === "table-highlight-red" ? "small-row-white" : ""}>{value.customer_invoice_number}</td>
                      <td className={highlightClass === "table-highlight-red" ? "small-row-white" : ""}>{value.customer2_invoice_number}</td>
                      <td className={highlightClass === "table-highlight-red" ? "small-row-white" : ""}>{value.vehicle.make}</td>
                      <td className={highlightClass === "table-highlight-red" ? "small-row-white" : ""}>{value.vehicle.model}</td>
                      {view === 'approved' &&
                      <td className={highlightClass === "table-highlight-red" ? "small-row-white" : ""}>{value.approving_user ? `${value.approving_user.first_name} ${value.approving_user.last_name}` : ""}</td>
                      }
                      {!value.priced ?
                        <td onClick={e => e.stopPropagation()}>
                          <Button
                            color={"success"}
                            onClick={(e) => onPriced(e, index)}
                          >
                            Priced
                          </Button>
                        </td> : <td></td>
                      }
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Column>
        </Columns>
        <PaginationWrapper
            setPage={setPage}
            page={page}
            dataCount={data ? Math.ceil(data.count / 25) : 0}
          ></PaginationWrapper>
        <InfoModal show={infoOpen} setShow={setInfoOpen}/>
      </Box>
    </div>
  );
}

export default Quote;
